// extracted by mini-css-extract-plugin
export default {"bars":"SectionContent_bars__+Gk5y","cards":"SectionContent_cards__-DOG4"};